import Layout from '@layout/Index'

export const occupationQuestionnaire = [
  {
    path: '/users/occupation-questionnaire',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "occupation-questionnaire-table" */ './pages/OccupationQuestionnaireTable.vue'),
        meta: {
          title: '自选职业推送列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "occupation-questionnaire-form" */ './pages/OccupationQuestionnaireForm.vue'),
        meta: {
          title: '添加自选职业推送',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "occupation-questionnaire-form" */ './pages/OccupationQuestionnaireForm.vue'),
        meta: {
          title: '修改自选职业推送',
        },
      },
      {
        path: 'preview/:id',
        component: () => import(/* webpackChunkName: "occupation-questionnaire-preview" */ './pages/OccupationQuestionnairePreview.vue'),
        meta: {
          title: '自选职业推送预览',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/occupation-questionnaire/occupation-questionnaire.route.js